import React from 'react'

import { Chip, Icon, ThemeProvider } from '@material-ui/core'

import { selectChip } from '../../services/theme'

export const DeletableChip = (props) => {
	const { onDelete, value } = props

	return (
		<ThemeProvider theme={selectChip}>
			{Boolean(onDelete) ? (
				<Chip
					value={value}
					deleteIcon={
						<div
							onMouseDown={(event) => {
								if (!props.disabled && event.button === 0) {
									event.stopPropagation()
									onDelete(value)
								}
							}}>
							<Icon className="MuiChip-deleteIcon fas fa-times" />
						</div>
					}
					{...props}
				/>
			) : (
				<Chip {...props} />
			)}
		</ThemeProvider>
	)
}
